module.exports = __webpack_public_path__ + "static/media/church.154e0b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/church.jpg
// module id = 211
// module chunks = 0